import { disableTabs, enableTabs } from '../helpers/tabFocus';
import { MODIFIERS, SELECTORS } from './config';

let currentActiveLevel = null;
const visibleMenus = {};
const activeToggles = {};

export default function init() {
    const mainNav = document.querySelector(SELECTORS.NAV);

    if (mainNav) {
        const baseToggles = [...document.querySelectorAll(SELECTORS.TOGGLE)];
        const levelToggles = [...document.querySelectorAll(SELECTORS.LEVEL_TOGGLE)];
        const mobileControls = [...document.querySelectorAll(SELECTORS.LEVEL_TOGGLE_MOBILE)];

        baseToggles.forEach((toggle) => {
            toggle.addEventListener('click', handleMainToggles);
        });

        levelToggles.forEach((toggle) => {
            const { level } = toggle.dataset;
            const target = level === '1'
                ? document.querySelector(SELECTORS.SUB_LIST_HOLDER_1)
                : document.querySelector(toggle.dataset.target);

            if (level === '1') {
                disableTabs(target);
            }

            toggle.addEventListener('click', handleLevelToggles);
        });

        mobileControls.forEach((control) => {
            control.addEventListener('click', handleMobileControls);
        });
    }
}

function handleMainToggles(e) {
    e.preventDefault();

    const toggle = e.currentTarget;
    const target = document.querySelector(toggle.dataset.target);
    const modifier = MODIFIERS.MAIN_NAV_OPEN;
    let isOpen = checkIsOpen({ target, modifier });

    toggleClass({ toggle, target, modifier, isOpen });
    isOpen = !isOpen;

    checkMobileControlVisibility();
}

function handleLevelToggles(e) {
    e.preventDefault();

    const toggle = e.currentTarget;
    const { level } = toggle.dataset;
    const modifier = MODIFIERS[`LEVEL_${level}_OPEN`];
    const target = level === '1'
        ? document.querySelector(SELECTORS.SUB_LIST_HOLDER_1)
        : document.querySelector(toggle.dataset.target);
    let isOpen = checkIsOpen({ target, modifier });
    const closeOthers = true;

    toggleClass({ toggle, target, modifier, isOpen, closeOthers, level });

    visibleMenus[level] = !isOpen ? target : null;
    activeToggles[level] = !isOpen ? toggle : null;
    isOpen = !isOpen;
    currentActiveLevel = isOpen ? parseInt(level, 10) : 1;
    checkMobileControlVisibility();
}

function handleMobileControls(e) {
    e.preventDefault();

    const control = e.currentTarget;
    const { level } = control.dataset;
    const modifier = MODIFIERS[`LEVEL_${level}_OPEN`];

    visibleMenus[level].classList.remove(modifier);
    activeToggles[level].classList.remove(MODIFIERS.TOGGLE_ACTIVE);
    visibleMenus[level] = null;
    activeToggles[level] = null;
    currentActiveLevel = parseInt(level, 10) - 1;
    checkMobileControlVisibility();
}

function checkIsOpen({ target, modifier }) {
    return target.classList.contains(modifier);
}

function toggleClass({ toggle, target, modifier, isOpen, level }) {
    const otherOpenSiblings = [...document.querySelectorAll(`.${modifier}`)];
    toggle.setAttribute('aria-expanded', !isOpen);
    target.setAttribute('aria-hidden', isOpen);

    if (level) {
        const levelToggles = [...document.querySelectorAll(SELECTORS.LEVEL_TOGGLE)];
        const { mobileControlText } = target.dataset;
        const mobileControl = document.querySelector(`.js-main-nav-toggle-level-mobile[data-level='${level}']`);

        if (mobileControlText) {
            mobileControl.querySelector(SELECTORS.LEVEL_TOGGLE_MOBILE_TEXT).textContent = mobileControlText;
        }

        levelToggles.forEach((levelToggle) => {
            if (levelToggle.dataset.level === level) {
                levelToggle.classList.remove(MODIFIERS.TOGGLE_ACTIVE);
            }
        });
    }

    if (otherOpenSiblings) {
        otherOpenSiblings.forEach((sibling) => {
            sibling.classList.remove(modifier);
        });
    }

    if (isOpen) {
        target.classList.remove(modifier);
        toggle.classList.remove(MODIFIERS.TOGGLE_ACTIVE);
        disableTabs(target);
    } else {
        target.classList.add(modifier);
        toggle.classList.add(MODIFIERS.TOGGLE_ACTIVE);
        enableTabs(target);
    }
}

function checkMobileControlVisibility() {
    const mobileControls = [...document.querySelectorAll(SELECTORS.LEVEL_TOGGLE_MOBILE)];

    mobileControls.forEach((mobileControl) => {
        mobileControl.classList.remove(MODIFIERS.LEVEL_TOGGLE_MOBILE_VISIBLE);
    });

    if (currentActiveLevel !== null) {
        for (let i = 0; i < currentActiveLevel; i++) {
            mobileControls[i].classList.add(MODIFIERS.LEVEL_TOGGLE_MOBILE_VISIBLE);
        }
    }
}
